'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = require('./required');

var _required2 = _interopRequireDefault(_required);

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (min, max) {
  return (0, _withParams2.default)({ type: 'between', min: min, max: max }, function (value) {
    return !(0, _required2.default)(value) || !/\s/.test(value) && Number(min) <= value && Number(max) >= value;
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/between.js
// module id = 778
// module chunks = 0